import React from "react";

import Navbar from "react-bootstrap/Navbar";
import "./header.scss";

import Imgrmuti from "../../images/rmutilogo.png";
import Nrct from "../../images/newnrct.png";
import Kmlogo from "../../images/kims-logo.png";
import { FaAngleUp } from "react-icons/fa";
import { AiFillHome } from "react-icons/ai";
import { Link } from "react-router-dom";

function Header() {
  const [visible, setVisible] = React.useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };
  const onTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  window.addEventListener("scroll", toggleVisible);

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="md"
        className="bg-header"
        variant="dark"
        // sticky="top"
      >
        <div className="nav-flex">
          <div className="brand-header">
            {/* <img src={Imgrmuti} className="img-logo" /> */}
            {/* <img src={Nrct} className="img-logo" />
          <img src={Kmlogo} className="img-logo" /> */}
            <img
              // src="https://kims-rmuti.com/monitoring/static/media/rmutilogo.1ee0d7da.png"
              src={Imgrmuti}
              style={{ width: "40px" }}
              className="d-inline-block align-top "
              alt="img-logo"
            />
            <img
              // src="https://kims-rmuti.com/monitoring/static/media/newnrct.135db279.png"
              src={Nrct}
              style={{ width: "60px", marginLeft: "5px" }}
              className="d-inline-block align-top"
              alt="img-logo"
            />
            <img
              // src="https://kims-rmuti.com/monitoring/static/media/rmuti-black.fb6f7579.png"
              src={Kmlogo}
              style={{ width: "300px", marginLeft: "5px" }}
              className="d-inline-block align-top"
              alt="img-logo"
            />

            {/* <div className="title-header">
            <h4>ระบบการจัดการความรู้และนวัตกรรม</h4>
          </div> */}
          </div>
          <div className="d-flex" style={{ alignItems: "center" }}>
            {/* <Link to={"/"}>
            <AiFillHome size={25} color="#fff" />
          </Link> */}
            <img
              style={{ paddingLeft: "2rem", paddingTop: "1rem" }}
              src="https://researcher.kims-rmuti.com/icon/rmutiname.png"
              width="350px"
              className="img-rmuti align-top"
              alt="rmuti-logo"
            />
          </div>
        </div>
      </Navbar>

      <div
        className="uptotop"
        onClick={onTop}
        style={{ display: visible ? "block" : "none" }}
      >
        <FaAngleUp style={{ marginTop: "5px", marginLeft: "5px" }} size={30} />
      </div>
    </>
  );
}

export default Header;
